import { handleSmoothAnchorScroll } from "@/helpers/scrollToProductPicker";
import parse from "html-react-parser";

type HowItWorksProps = {
  tr_heading: string;
  tr_description: string;
  section_image: string | null;
  cta?: {
    show: boolean;
    label: string;
    url: string;
  };
};

export const HowItWorks = ({
  tr_heading,
  tr_description,
  section_image,
  cta,
}: HowItWorksProps) => (
  <div className="split-layout content-wide">
    {section_image && (
      <div className="content-left">
        <div className="how-it-works-image-container">
          <img src={section_image} alt="" className="how-it-works-image" />
        </div>
      </div>
    )}

    <div className="content-right">
      <section className="upsell-header">
        <h2 className="upsell-title section-heading how">
          {parse(tr_heading)}
        </h2>

        <div className="upsell-subtitle how">{parse(tr_description)}</div>

        {cta?.show && (
          <div className="cta-section cta-left">
            <a
              href={cta.url}
              className="pay-btn add-to-order-btn"
              onClick={(e) => handleSmoothAnchorScroll(e)}
            >
              {cta.label}
            </a>
          </div>
        )}
      </section>
    </div>
  </div>
);
